import React, { useState, useEffect } from 'react';
import Modal from '@mui/material/Modal';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Select from 'react-select';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import Swal from 'sweetalert2';
import { baseurlvmkp } from '../Files/Subjects/Baseurl';
import axios from 'axios';

const genderOptions = [
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
  { label: 'Other', value: 'Other' },
];

const maritalStatusOptions = [
  { label: 'Single', value: 'Single' },
  { label: 'Married', value: 'Married' },
  { label: 'Divorced', value: 'Divorced' },
  { label: 'Widowed', value: 'Widowed' },
];

const occupationOptions = [
  { value: 'student', label: 'Student' },
  { value: 'Employed', label: 'Employed' },
  { value: 'Unemployed', label: 'Unemployed' },
  { value: 'Self-employed', label: 'Self-employed' },
  { value: 'Business-Person', label: 'Business Person' },
];

const Modalc2 = ({ isModalOpen, closeModal }) => {
  const [formData, setFormData] = useState({
    first_name: '',
    last_name: '',
    phone_no: '',
    email: '',
    gender: '',
    marital_status: '',
    country: '',
    states: '',
    city: '',
    occupation: '',
    address: '',
    birth_date: '',
    age: 0
  });

  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [selectedYear, setSelectedYear] = useState('');
  const [selectedMonth, setSelectedMonth] = useState('');
  const [selectedDate, setSelectedDate] = useState('');
  const [availableDays, setAvailableDays] = useState([]);
  const [password, setPassword] = useState('');
  const [erroremail, setErroremail] = useState(false);
  const [loginloading, setLoginloading] = useState(false);

  // Initialize form data when modal opens
  useEffect(() => {
    if (!isModalOpen) return;

    const fetchUserData = async () => {
      try {
        const userData = JSON.parse(localStorage.getItem("user"));
        const response = await axios.get(`${baseurlvmkp}/vmkp/get/${userData.details.id}`, {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        });

        const user = response.data;
        const [year, month, day] = user.birth_date.split('-');

      const cleanedUser = Object.entries(user).reduce((acc, [key, value]) => {
  if (key === 'password') return acc;

  if (['country', 'states', 'city'].includes(key)) {
    acc[key] = value?.id || '';
  } else {
    acc[key] = value;
  }

  return acc;
}, {});

setFormData(cleanedUser);


        setSelectedYear(year);
        setSelectedMonth(month);
        setSelectedDate(day);

        // Fetch states if country exists
        if (user.country?.id) {
          fetchStates(user.country.id);
        }

        // Fetch cities if state exists
        if (user.states?.id) {
          fetchCities(user.states.id);
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    const fetchCountries = async () => {
      try {
        const response = await fetch(`${baseurlvmkp}/country/get`);
        const data = await response.json();
        setCountries(data.map(item => ({ label: item.name, value: item.id })));
      } catch (error) {
        console.error('Error fetching countries:', error);
      }
    };

    fetchUserData();
    fetchCountries();
  }, [isModalOpen]);

  const fetchStates = async (countryId) => {
    try {
      const response = await fetch(`${baseurlvmkp}/state/get/${countryId}`);
      const data = await response.json();
      setStates(data.map(item => ({ label: item.name, value: item.id })));
    } catch (error) {
      console.error('Error fetching states:', error);
    }
  };

  const fetchCities = async (stateId) => {
    try {
      const response = await fetch(`${baseurlvmkp}/city/get/${stateId}`);
      const data = await response.json();
      setCities(data.map(item => ({ label: item.name, value: item.id })));
    } catch (error) {
      console.error('Error fetching cities:', error);
    }
  };

  const handleChange = (name, value) => {
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));

    // Handle cascading updates for country/state/city
    if (name === 'country') {
      setStates([]);
      setCities([]);
      setFormData(prev => ({ ...prev, states: '', city: '' }));
      if (value) fetchStates(value);
    } else if (name === 'states') {
      setCities([]);
      setFormData(prev => ({ ...prev, city: '' }));
      if (value) fetchCities(value);
    }
  };

  const calculateAge = (dob) => {
    const today = new Date();
    const birthDate = new Date(dob);
    let age = today.getFullYear() - birthDate.getFullYear();
    const monthDiff = today.getMonth() - birthDate.getMonth();
    if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.first_name) newErrors.first_name = 'First name is required';
    if (!formData.last_name) newErrors.last_name = 'Last name is required';
    if (!formData.phone_no) newErrors.phone_no = 'Phone number is required';
    if (!formData.email) newErrors.email = 'Email is required';
    if (!formData.gender) newErrors.gender = 'Gender is required';
    if (!formData.marital_status) newErrors.marital_status = 'Marital status is required';
    if (!formData.country) newErrors.country = 'Country is required';
    if (!formData.states) newErrors.states = 'State is required';
    if (!formData.city) newErrors.city = 'City is required';
    if (!formData.occupation) newErrors.occupation = 'Occupation is required';
    if (!selectedYear || !selectedMonth || !selectedDate) newErrors.dob = 'Date of Birth is required';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async () => {
    if (!validate()) {
      Swal.fire('Error', 'Please fix the errors in the form.', 'error');
      return;
    }

    try {
      setLoginloading(true);
      
      const dob = `${selectedYear}-${String(selectedMonth).padStart(2, '0')}-${String(selectedDate).padStart(2, '0')}`;
      const age = calculateAge(dob);

      const payload = {
        ...formData,
        birth_date: dob,
        age,
        email: formData.email?.trim(),
        password: password?.trim(),
        country: { id: formData.country },
        states: { id: formData.states },
        city: { id: formData.city },
        ...(password ? { password } : {})
      };

      const response = await axios.put(
        `${baseurlvmkp}/vmkp/put/${formData.id}`,
        payload,
        {
          headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
        }
      );

      Swal.fire({
        title: 'Success!',
        text: 'Profile updated successfully!',
        icon: 'success',
        confirmButtonText: 'OK',
      });

      closeModal();
      setErroremail(false);
    } catch (error) {
      console.error('Error:', error);
      console.log(error);
      if (error.response && error.response.data === 'Email Already Exist') {
        setErroremail(true);
        Swal.fire({
          title: 'Error!',
          text: 'This email already exists.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      } else {
        Swal.fire({
          title: 'Error!',
          text: 'There was an error updating the profile.',
          icon: 'error',
          confirmButtonText: 'OK',
        });
      }
    } finally {
      setLoginloading(false);
    }
  };

  // Date selection options
  const years = Array.from({ length: 100 }, (_, i) => ({
    label: `${2024 - i}`, value: `${2024 - i}`,
  }));

  const months = [
    { label: 'January', value: '01' },
    { label: 'February', value: '02' },
    { label: 'March', value: '03' },
    { label: 'April', value: '04' },
    { label: 'May', value: '05' },
    { label: 'June', value: '06' },
    { label: 'July', value: '07' },
    { label: 'August', value: '08' },
    { label: 'September', value: '09' },
    { label: 'October', value: '10' },
    { label: 'November', value: '11' },
    { label: 'December', value: '12' },
  ];

  // Update available days when year or month changes
  useEffect(() => {
    if (selectedYear && selectedMonth) {
      const daysInMonth = new Date(selectedYear, selectedMonth, 0).getDate();
      const days = Array.from({ length: daysInMonth }, (_, i) => ({
        label: `${i + 1}`, value: `${String(i + 1).padStart(2, '0')}`,
      }));
      setAvailableDays(days);
      
      // Reset selected date if it's no longer valid
      if (selectedDate && parseInt(selectedDate) > daysInMonth) {
        setSelectedDate('');
      }
    } else {
      setAvailableDays([]);
    }
  }, [selectedYear, selectedMonth]);

  // const customStyles = {
  //   control: (provided) => ({
  //     ...provided,
  //     minHeight: '56px',
  //     borderColor: errors.country ? '#d32f2f' : '#ced4da',
  //     '&:hover': {
  //       borderColor: errors.country ? '#d32f2f' : '#80bdff',
  //     },
  //   }),
  //   placeholder: (provided) => ({
  //     ...provided,
  //     color: errors.country ? '#d32f2f' : '#6c757d',
  //   })
  // };
  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "#f0f8ff" : "#ffffff", 
      borderColor: state.isFocused ? "#007bff" : "#ced4da", 
      boxShadow: state.isFocused ? "0 0 0 1px #007bff" : null,
      ":hover": {
        borderColor: "#007bff",
      },
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "#007bff" 
        : state.isFocused
        ? "#e9f5ff" 
        : null,
      color: state.isSelected ? "#ffffff" : "#000000",
    }),
    placeholder: (provided) => ({
      ...provided,
      color: "#6c757d", 
    }),
    singleValue: (provided) => ({
      ...provided,
      color: "#495057", 
    }),
  };
  const getSelectValue = (options, value) => {
    if (!value) return null;
    const option = options.find(opt => opt.value === value);
    return option ? { label: option.label, value: option.value } : null;
  };

  const handleModalClose = (_, reason) => {
    if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
      return;
    }
    closeModal();
  };

  return (
    <Modal
      open={isModalOpen}
      onClose={handleModalClose}
      disableEscapeKeyDown
      aria-labelledby="modal-title"
      aria-describedby="modal-description"
      style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <div style={{ 
        background: '#fff', 
        padding: '30px', 
        borderRadius: '10px', 
        width: '800px',
        maxHeight: '90vh',
        overflowY: 'auto'
      }}>
        <Typography id="modal-title" variant="h5" align="center" gutterBottom>
          Edit Profile
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="First Name"
              name="first_name"
              value={formData.first_name || ''}
              onChange={(e) => handleChange('first_name', e.target.value)}
              error={!!errors.first_name}
              helperText={errors.first_name}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Last Name"
              name="last_name"
              value={formData.last_name || ''}
              onChange={(e) => handleChange('last_name', e.target.value)}
              error={!!errors.last_name}
              helperText={errors.last_name}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Phone Number"
                type="number"

              name="phone_no"
              value={formData.phone_no || ''}
              onChange={(e) => handleChange('phone_no', e.target.value)}
              error={!!errors.phone_no}
              helperText={errors.phone_no}
            />
          </Grid>
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Email"
                type="email"

              name="email"
              value={formData.email || ''}
              onChange={(e) => handleChange('email', e.target.value)}
              error={!!errors.email}
              helperText={errors.email}
            />
            {erroremail && <Typography color="error">This email already exists</Typography>}
          </Grid>
          
          <Grid item xs={6}>
            <TextField
              fullWidth
              type={showPassword ? 'text' : 'password'}
              label="Password (leave blank to keep current)"
              name="password"
              value={password}
              autoComplete="new-password"
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? <FaEyeSlash /> : <FaEye />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          
          <Grid item xs={6}>
            <Select
              styles={customStyles}
              options={maritalStatusOptions}
              value={getSelectValue(maritalStatusOptions, formData.marital_status)}
              onChange={(option) => handleChange('marital_status', option.value)}
              placeholder="Marital Status"
              isSearchable
            />
            {errors.marital_status && <Typography color="error">{errors.marital_status}</Typography>}
          </Grid>
          
          <Grid item xs={12}>
            <Typography variant="subtitle2" gutterBottom>Date of Birth:</Typography>
            <div style={{ display: 'flex', gap: '6px' }}>
              <Select
                styles={customStyles}
                options={years}
                value={getSelectValue(years, selectedYear)}
                onChange={(option) => {
                  setSelectedYear(option.value);
                  setSelectedMonth('');
                  setSelectedDate('');
                }}
                placeholder="Year"
              />
              <Select
                styles={customStyles}
                options={months}
                value={getSelectValue(months, selectedMonth)}
                onChange={(option) => {
                  setSelectedMonth(option.value);
                  setSelectedDate('');
                }}
                placeholder="Month"
                isDisabled={!selectedYear}
              />
              <Select
                styles={customStyles}
                options={availableDays}
                value={getSelectValue(availableDays, selectedDate)}
                onChange={(option) => setSelectedDate(option.value)}
                placeholder="Day"
                isDisabled={!selectedMonth}
              />
            </div>
            {errors.dob && <Typography color="error">{errors.dob}</Typography>}
          </Grid>
          
          <Grid item xs={6}>
            <Select
              styles={customStyles}
              options={genderOptions}
              value={getSelectValue(genderOptions, formData.gender)}
              onChange={(option) => handleChange('gender', option.value)}
              placeholder="Gender"
              isSearchable
            />
            {errors.gender && <Typography color="error">{errors.gender}</Typography>}
          </Grid>
          
          <Grid item xs={6}>
            <Select
              styles={customStyles}
              options={countries}
              value={getSelectValue(countries, formData.country)}
              onChange={(option) => handleChange('country', option.value)}
              placeholder="Country"
              isSearchable
            />
            {errors.country && <Typography color="error">{errors.country}</Typography>}
          </Grid>
          
          <Grid item xs={6}>
            <Select
              styles={customStyles}
              options={states}
              value={getSelectValue(states, formData.states)}
              onChange={(option) => handleChange('states', option.value)}
              placeholder="State"
              isSearchable
              isDisabled={!formData.country}
            />
            {errors.states && <Typography color="error">{errors.states}</Typography>}
          </Grid>
          
          <Grid item xs={6}>
            <Select
              styles={customStyles}
              options={cities}
              value={getSelectValue(cities, formData.city)}
              onChange={(option) => handleChange('city', option.value)}
              placeholder="City"
              isSearchable
              isDisabled={!formData.states}
            />
            {errors.city && <Typography color="error">{errors.city}</Typography>}
          </Grid>
          
          <Grid item xs={6}>
            <Select
              styles={customStyles}
              options={occupationOptions}
              value={getSelectValue(occupationOptions, formData.occupation)}
              onChange={(option) => handleChange('occupation', option.value)}
              placeholder="Occupation"
              isSearchable
            />
            {errors.occupation && <Typography color="error">{errors.occupation}</Typography>}
          </Grid>
          
          <Grid item xs={6}>
            <TextField
              fullWidth
              label="Address"
              name="address"
              value={formData.address || ''}
              onChange={(e) => handleChange('address', e.target.value)}
              multiline
              rows={2}
            />
          </Grid>
          
          <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end', gap: '16px' }}>
            <Button variant="outlined" onClick={closeModal}>
              Cancel
            </Button>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleSubmit}
              disabled={loginloading}
            >
              {loginloading ? 'Updating...' : 'Update Profile'}
            </Button>
          </Grid>
        </Grid>
      </div>
    </Modal>
  );
};

export default Modalc2;
